"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const lodash_1 = require("lodash");
const styled_components_1 = __importDefault(require("styled-components"));
const bridge_schema_1 = require("@completeanatomy/bridge-schema");
const i18n_1 = require("@completeanatomy/i18n");
const licenses_1 = require("@completeanatomy/licenses");
const ui_1 = require("@completeanatomy/ui");
const user_1 = require("@completeanatomy/user");
const react_1 = require("react");
const atoms_1 = require("../../atoms");
const hooks_1 = require("../../hooks");
const InviteMultipleMembersButton_1 = __importDefault(require("../../molecules/InviteMultipleMembersButton"));
const GroupEditMembersSearch_1 = __importDefault(require("../GroupEditMembersSearch"));
const index_1 = require("../index");
const license_1 = require("../../utils/license");
function GroupEditMembers({ group }) {
    var _a;
    const [members, setMembers] = (0, react_1.useState)((_a = group === null || group === void 0 ? void 0 : group.members) !== null && _a !== void 0 ? _a : []);
    const { users, search } = (0, user_1.useSearchUsers)();
    const [isUsersLoading, setIsUsersLoading] = (0, react_1.useState)(false);
    const [isMembersLoading, setIsMembersLoading] = (0, react_1.useState)(false);
    const sharingService = (0, hooks_1.useSharing)();
    const licenses = (0, licenses_1.useUserLicenses)();
    const isEducatorLicence = licenses
        ? (0, license_1.getActiveEduLicence)(licenses)
        : undefined;
    (0, react_1.useEffect)(() => {
        var _a;
        setMembers((_a = group === null || group === void 0 ? void 0 : group.members) !== null && _a !== void 0 ? _a : []);
    }, [group === null || group === void 0 ? void 0 : group.members]);
    const onAdd = (user) => {
        setMembers(prevState => [
            ...prevState,
            {
                identifier: -1,
                avatar: user.image,
                status: bridge_schema_1.MembershipStatus.NotMember,
                isAdmin: false,
                name: user.label,
                isFounder: false,
                userIdentifier: user.identifier,
            },
        ]);
    };
    const onSearchUsers = (0, lodash_1.debounce)((searchValue) => __awaiter(this, void 0, void 0, function* () {
        search(searchValue).finally(() => {
            setIsUsersLoading(false);
        });
    }), 1000);
    const onRemoveMember = (membership) => {
        if (membership.identifier !== -1) {
            /**
             * Don't need to remove existing membership here, they'll be removed on the backend side and we'll get updated list
             */
            return;
        }
        setMembers(prevState => prevState.filter(m => m.userIdentifier !== membership.userIdentifier));
    };
    (0, react_1.useEffect)(() => {
        setIsMembersLoading(true);
        sharingService === null || sharingService === void 0 ? void 0 : sharingService.getMembersByGroup(group.identifier).finally(() => {
            setIsMembersLoading(false);
        });
    }, [group.identifier, sharingService]);
    if (group.identifier === bridge_schema_1.GroupID.New) {
        return ((0, jsx_runtime_1.jsx)(Placeholder, { "data-e2e": 'GroupEditMembers_Placeholder', children: (0, i18n_1.Localized)(i18n_1.Strings.groups.edit.members.saveBefore) }));
    }
    const spinner = ((0, jsx_runtime_1.jsx)(SpinnerContainer, { "data-e2e": 'GroupEditMembers_SpinnerContainer', children: (0, jsx_runtime_1.jsx)(atoms_1.Spinner, { "data-e2e": 'GroupEditMembers_Spinner' }) }));
    const userList = ((0, jsx_runtime_1.jsx)(UserList, { "data-e2e": 'GroupEditMembers_UserList', children: members.map((membership, index) => ((0, jsx_runtime_1.jsx)(index_1.GroupMembersUserItem, { index: index + 1, membership: membership, group: group, onRemove: onRemoveMember, "data-e2e": 'GroupEditMembers_GroupMembersUserItem' }, index))) }));
    return ((0, jsx_runtime_1.jsxs)(Container, { "data-e2e": 'GroupEditMembers_Container', children: [(0, jsx_runtime_1.jsx)(Title, { "data-e2e": 'GroupEditMembers_Title', children: (0, i18n_1.Localized)(i18n_1.Strings.groups.edit.members.title) }), (0, jsx_runtime_1.jsx)(SubTitle, { "data-e2e": 'GroupEditMembers_SubTitle', children: (0, i18n_1.Localized)(i18n_1.Strings.groups.edit.members.subtitle) }), (0, jsx_runtime_1.jsx)(UserSearch, { users: users, onSelect: onAdd, isLoading: isUsersLoading, onSearch: onSearchUsers, setIsLoading: setIsUsersLoading, "data-e2e": 'GroupEditMembers_UserSearch' }), isEducatorLicence && ((0, jsx_runtime_1.jsx)(ButtonWrapper, { "data-e2e": 'GroupEditMembers_ButtonWrapper', children: (0, jsx_runtime_1.jsx)(InviteMultipleMembersButton_1.default, { buttonText: (0, i18n_1.Localized)(i18n_1.Strings.groups.edit.members.inviteMultiple), groupId: group.identifier, "data-e2e": 'GroupEditMembers_InviteMultipleMembersButton' }) })), isMembersLoading ? spinner : userList] }));
}
exports.default = (0, user_1.withUserServiceProvider)(GroupEditMembers);
const Container = styled_components_1.default.div `
  display: flex;
  flex-direction: column;
  flex-grow: 1;

  width: 500px;

  margin: 0 auto;

  overflow: hidden;
`;
const Title = styled_components_1.default.div `
  margin: 30px 0 5px 45px;

  color: ${props => props.theme.text};

  font-size: 16px;
`;
const SubTitle = styled_components_1.default.div `
  margin: 0 0 0 45px;

  color: ${props => props.theme.text};

  font-size: 12px;
`;
const UserSearch = (0, styled_components_1.default)(GroupEditMembersSearch_1.default) `
  width: 100%;

  margin: 10px 0 30px 0;
`;
const UserList = (0, styled_components_1.default)(ui_1.SimpleScrollView) `
  display: flex;
  flex-direction: column;
  flex: 1 1 100%;

  box-sizing: border-box;

  width: 100%;

  padding: 0 0 0 30px;
`;
const Placeholder = styled_components_1.default.div `
  margin: auto;

  color: ${props => props.theme.textSecondary};

  font-size: 18px;
  text-align: center;
`;
const SpinnerContainer = styled_components_1.default.div `
  display: flex;

  width: 100%;
  height: 100%;
`;
const ButtonWrapper = styled_components_1.default.div `
  display: flex;
  justify-content: flex-start;

  margin: 0 30px;
`;
